import { Component, OnInit } from '@angular/core';
import { User, AuthenticationService } from '@csx/security';
import { Router } from '@angular/router';
import { LocalStorageService } from '../services/localstorage.service';

@Component({
  selector: 'app-userverification',
  templateUrl: './userverification.component.html',
  styleUrls: ['./userverification.component.scss']
})
export class UserverificationComponent implements OnInit {
  userName: string;

  constructor(private user: User, private router: Router, private authService: AuthenticationService, private localStorage: LocalStorageService) { }

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user'));
    this.userName = user.firstName + " " + user.lastName;
  }

  verifyUser(isVerified) {
    if (isVerified) {
      this.router.navigate(['/authorities'], { queryParams: { status: 'open' } })
    } else {
      this.authService.logout();
      this.router.navigate(['/welcome']);
    }
  }
}
